export default __webpack_public_path__ + "static/media/cientifica1.eddf0cd3.jpg";